/* Western Hunter side cart: open after Add to cart, edit quantities, check out. */
(function () {
  'use strict';
  var root = document.getElementById('whCart');
  if (!root) return;

  var body = document.getElementById('whCartBody');
  var foot = document.getElementById('whCartFoot');
  var panel = root.querySelector('.wh-sidecart__panel');
  var lastFocus = null;
  var onCartPage = /^\/cart(\/|$)/.test(location.pathname);

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(cents, currency) {
    try {
      return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: currency || 'USD' });
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function thumb(url) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=200';
  }

  function setBadge(count) {
    var link = document.querySelector('.wh-header__cart');
    if (!link) return;
    var badge = link.querySelector('.wh-header__cart-badge');
    if (count > 0) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'wh-header__cart-badge';
        link.appendChild(badge);
      }
      badge.textContent = count;
    } else if (badge) {
      badge.remove();
    }
  }

  // "Want an issue right away?": single issues offered when the cart holds a subscription (data from snippets/wh-issue-upsell.liquid).
  var upsell = [];
  try { upsell = JSON.parse(document.getElementById('whUpsellData').textContent) || []; } catch (e) { upsell = []; }

  function upsellHtml(cart) {
    var hasPlan = cart.items.some(function (item) { return item.selling_plan_allocation; });
    if (!upsell.length || !hasPlan) return '';
    var inCart = {};
    cart.items.forEach(function (item) { inCart[item.variant_id] = true; });
    var list = upsell.filter(function (u) { return !inCart[u.id]; });
    if (!list.length) return '';
    return '<section class="wh-upsell">' +
      '<h3 class="wh-upsell__title">Want an issue right away?</h3>' +
      '<p class="wh-upsell__sub">Add a single issue to this order.</p>' +
      '<ul class="wh-upsell__list">' + list.map(function (u) {
        return '<li class="wh-upsell__item">' +
          '<a class="wh-sidecart__img wh-upsell__img" href="' + esc(u.url) + '">' + (u.image ? '<img src="' + esc(u.image) + '" alt="" width="56" height="56" loading="lazy">' : '') + '</a>' +
          '<div class="wh-upsell__info"><a class="wh-upsell__name" href="' + esc(u.url) + '">' + esc(u.title) + '</a>' +
          '<span class="wh-upsell__price">' + money(u.price, cart.currency) + '</span></div>' +
          '<button type="button" class="wh-upsell__add" data-wh-upsell-add="' + Number(u.id) + '">Add</button>' +
        '</li>';
      }).join('') + '</ul></section>';
  }

  function render(cart) {
    setBadge(cart.item_count);

    if (!cart.items.length) {
      body.innerHTML =
        '<div class="wh-sidecart__empty"><p>Your cart is empty.</p>' +
        '<a class="btn btn-red btn-lg" href="/collections/all"><span>Continue shopping</span></a></div>';
      foot.innerHTML = '';
      foot.hidden = true;
      return;
    }

    body.innerHTML = '<ul class="wh-sidecart__items">' + cart.items.map(function (item, i) {
      var line = i + 1;
      var variant = item.variant_title && !/^(default( title)?)$/i.test(item.variant_title) ? item.variant_title : '';
      var plan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan ? item.selling_plan_allocation.selling_plan.name : '';
      var meta = [variant, plan].filter(Boolean).map(esc).join(' &middot; ');
      var compare = item.original_line_price > item.final_line_price
        ? '<s class="wh-sidecart__was">' + money(item.original_line_price, cart.currency) + '</s> ' : '';
      return '<li class="wh-sidecart__item">' +
        '<a class="wh-sidecart__img" href="' + esc(item.url) + '">' +
          (item.image ? '<img src="' + esc(thumb(item.image)) + '" alt="' + esc(item.product_title) + '" width="88" height="88" loading="lazy">' : '') +
        '</a>' +
        '<div class="wh-sidecart__info">' +
          '<a class="wh-sidecart__name" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
          (meta ? '<div class="wh-sidecart__meta">' + meta + '</div>' : '') +
          '<div class="wh-sidecart__row">' +
            '<div class="wh-sidecart__qty" role="group" aria-label="Quantity">' +
              '<button type="button" data-wh-qty="' + line + ':' + (item.quantity - 1) + '" aria-label="Decrease quantity">&minus;</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-wh-qty="' + line + ':' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<div class="wh-sidecart__price">' + compare + money(item.final_line_price, cart.currency) + '</div>' +
          '</div>' +
          '<button type="button" class="wh-sidecart__remove" data-wh-qty="' + line + ':0">Remove</button>' +
        '</div></li>';
    }).join('') + '</ul>' + upsellHtml(cart);

    foot.hidden = false;
    foot.innerHTML =
      '<div class="wh-sidecart__sub"><span>Subtotal</span><strong>' + money(cart.items_subtotal_price, cart.currency) + '</strong></div>' +
      '<p class="wh-sidecart__note">Shipping and taxes are calculated at checkout.</p>' +
      '<a class="btn btn-red btn-lg wh-sidecart__checkout" href="/checkout"><span>Checkout</span></a>' +
      '<a class="wh-sidecart__view" href="/cart">View cart</a>';
  }

  function refresh() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); return cart; });
  }

  function open() {
    if (root.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('wh-sidecart-lock');
    panel.focus();
  }

  function close() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('wh-sidecart-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function refreshAndOpen() {
    return refresh().then(function (cart) { open(); return cart; });
  }

  function changeLine(line, qty) {
    body.classList.add('is-busy');
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(qty) })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); })
      .catch(function () { return refresh(); })
      .then(function () {
        body.classList.remove('is-busy');
        if (document.activeElement === document.body) panel.focus();
      });
  }

  function showFormError(form, message) {
    var el = form.querySelector('.wh-sidecart-error');
    if (!el) {
      el = document.createElement('p');
      el.className = 'wh-sidecart-error';
      el.setAttribute('role', 'alert');
      var btn = form.querySelector('[type="submit"]');
      (btn && btn.parentNode ? btn.parentNode : form).appendChild(el);
    }
    el.textContent = message;
  }

  // Product forms (PDP and featured product): add via AJAX, then open the drawer.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.getAttribute || !/\/cart\/add/.test(form.getAttribute('action') || '')) return;
    if (form.querySelector('input[name="return_to"]')) return;
    e.preventDefault();
    e.stopImmediatePropagation();

    var btn = form.querySelector('[type="submit"]');
    var old = form.querySelector('.wh-sidecart-error');
    if (old) old.remove();
    if (btn) btn.disabled = true;

    fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.json.description || res.json.message || 'Could not add this item to the cart.');
        return refreshAndOpen();
      })
      .catch(function (err) { showFormError(form, err.message); })
      .then(function () { if (btn) btn.disabled = false; });
  }, true);

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-wh-cart-close]')) { close(); return; }

    var addBtn = t.closest('[data-wh-upsell-add]');
    if (addBtn) {
      addBtn.disabled = true;
      addBtn.textContent = 'Adding';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(addBtn.getAttribute('data-wh-upsell-add')), quantity: 1 }] })
      })
        .then(function (r) {
          if (!r.ok) { addBtn.disabled = false; addBtn.textContent = 'Try again'; return; }
          if (onCartPage) { location.reload(); return; }
          return refresh().then(function () { panel.focus(); });
        })
        .catch(function () { refresh(); });
      return;
    }

    var qtyBtn = t.closest('[data-wh-qty]');
    if (qtyBtn) {
      var p = qtyBtn.getAttribute('data-wh-qty').split(':');
      changeLine(p[0], Math.max(0, Number(p[1])));
      return;
    }

    // Header cart icon opens the drawer (the cart page itself keeps its link).
    var cartLink = t.closest('.wh-header__cart');
    if (cartLink && !onCartPage && !e.metaKey && !e.ctrlKey && !e.shiftKey) {
      e.preventDefault();
      refreshAndOpen();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) close();
  });

  // Cart page: fill the upsell block under the line items.
  var upsellMount = document.querySelector('[data-wh-upsell-mount]');
  if (upsellMount) {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { upsellMount.innerHTML = upsellHtml(cart); });
  }

  window.WHCart = { open: open, close: close, refresh: refresh, refreshAndOpen: refreshAndOpen };
})();
